<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="6">
        <span class="text-h5 pl-4">Vehicle Availability</span>
      </v-col>
    </v-row>

    <v-row class="ma-0 mt-0 pt-0">
      <v-col cols="12" class="pr-0">
        <v-row class="ma-0">
          <v-col class="text-center" cols="12" sm="6" md="3">
            <v-card class="rounded-lg pa-3 hover-effect vehicle-card" outlined
              style="height: 100%; background-color: white; min-height: 140px;">
              <div class="d-flex justify-space-between align-start mb-2">
                <div>
                  <div class="mb-2">
                    <span class="text-body-1 text-dark">Total Vehicles</span>
                  </div>
                  <div>
                    <span class="text-h5 font-weight-bold text-dark">{{ statistics.total_vehicles || 0 }}</span>
                  </div>
                </div>
                <div class="icon-container">
                  <v-icon color="white" size="20" class="rounded-lg pa-2" style="background-color: #4285F4">
                    mdi-truck
                  </v-icon>
                </div>
              </div>

              <div class="d-flex align-center mt-auto pt-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" color="info" small outlined class="mr-2">
                      <v-icon left small>mdi-information</v-icon>
                      info
                    </v-chip>
                  </template>
                  <span>Total No. of Vehicles</span>
                </v-tooltip>
              </div>
            </v-card>
          </v-col>

          <v-col class="text-center" v-for="(item, index) in cards" :key="index" cols="12" sm="6" md="2">
            <v-card class="rounded-lg pa-3 hover-effect vehicle-card" outlined
              style="height: 100%; background-color: white; min-height: 140px;" @click="item.click && item.click()">
              <div class="d-flex justify-space-between align-start mb-2">
                <div>
                  <div class="mb-2">
                    <span class="text-body-1 text-dark">{{ item.label }}</span>
                  </div>
                  <div>
                    <span class="text-h5 font-weight-bold text-dark">{{ item.value }}</span>
                  </div>
                </div>
                <div class="icon-container">
                  <v-icon :color="item.iconColor" size="20" class="rounded-lg pa-2"
                    :style="`background-color: ${item.iconBgColor}`">
                    {{ item.icon }}
                  </v-icon>
                </div>
              </div>

              <div class="d-flex align-center mt-auto pt-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" :color="item.statusColor" small outlined class="mr-2">
                      <v-icon left small>{{ item.statusIcon }}</v-icon>
                      {{ item.status }}
                    </v-chip>
                  </template>
                  <span>{{ item.tooltipMessage || "No details available" }}</span>
                </v-tooltip>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="ma-0 mt-4">
      <v-col cols="12">
        <v-card class="rounded-lg elevation-2" outlined>
          <v-card-title class="d-flex justify-space-between align-center pa-5"
            style="background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);">
            <div>
              <span class="text-h5 font-weight-bold" style="color: white;">
                Depot Wise Availability
              </span>
              <div class="text-body-2 text-white opacity-90 mt-1">
                Vehicle distribution across depots
              </div>
            </div>
            <div class="d-flex align-center">
              
              <v-select
                v-model="selectedStatus"
                :items="statusOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                class="status-filter mr-3"
                prepend-inner-icon="mdi-filter-variant"
                style="min-width: 200px; background-color: white; border-radius: 8px;"
                 @change="onStatusChange"
              >
                <template v-slot:selection="{ item }">
                  <span class="font-weight-medium">{{ item.text }}</span>
                </template>
              </v-select>
              
              <v-btn
                color="white"
                class="export-btn"
                :loading="isExporting"
                @click="exportVehicleData"
              >
                <v-icon left>mdi-download</v-icon>
                Export
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text class="pa-0">
            <div class="white rounded-b-lg">
              <!-- Table Header -->
              <v-row class="ma-0 py-4 px-5 bg-grey-lighten-4 table-header">
                <v-col v-for="(header, index) in tableHeaders" :key="'header-' + index"
                  :cols="index === 0 ? 6 : 6" :class="[
                    header.align === 'center' ? 'text-center' : 'text-left',
                    'font-weight-bold text-body-1',
                    'd-flex align-center'
                  ]" style="min-height: 50px;">
                  <span class="text-truncate">{{ header.title }}</span>
                </v-col>
              </v-row>

              <!-- Table Rows -->
              <div v-for="(row, index) in filteredTableData" :key="'row-' + index">
                <v-row class="ma-0 py-4 px-5 align-center table-row"
                  :class="index % 2 === 0 ? 'white' : 'bg-grey-lighten-5'" style="min-height: 70px;">
                  
                  <!-- Depot Name Column -->
                  <v-col cols="6" class="d-flex align-center text-left">
                    <v-icon color="orange" class="mr-3" size="24">mdi-home-city</v-icon>
                    <span class="text-body-1 font-weight-bold text-truncate">
                      {{ row.depot }}
                    </span>
                  </v-col>

                  <!-- Count Column -->
                  <v-col cols="6" class="text-center d-flex align-center justify-center">
                    <div class="d-flex align-center justify-center column-content">
                      <v-chip :color="getChipColor(getRowCountValue(row))" size="default" 
                        class="font-weight-bold px-4 py-5">
                        <span class="text-h6">{{ getRowCountValue(row) }}</span>
                      </v-chip>
                      <v-btn v-if="getRowCountValue(row) > 0" icon class="ml-2 expand-btn"
                        style="background-color: #FFE5B4; width: 32px; height: 32px;"
                        @click="toggleExpand(row.depot)"
                        :aria-label="`Expand ${row.depot} details`">
                        <v-icon size="18" color="orange"
                          :class="{ 'rotate-180': isExpanded(row.depot) }">
                          mdi-chevron-down
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <!-- Expanded Vehicle Details -->
                <v-expand-transition>
                  <div v-if="isExpanded(row.depot) && getRowVehiclesData(row).length > 0">
                    <div class="pa-5 bg-orange-lighten-5">
                      <div class="mb-4 d-flex align-center">
                        <v-icon color="orange" size="20" class="mr-2">mdi-truck-check</v-icon>
                        <span class="text-h6 font-weight-bold">
                          {{ row.depot }} - Vehicle Details
                        </span>
                    
                        <v-chip color="orange" size="small" class="ml-3 font-weight-bold" style="color: white;">
                        {{ getRowVehiclesData(row).length }} vehicles
                        </v-chip>

                      </div>
                      <v-row class="ma-0">
                        <v-col v-for="vehicle in getRowVehiclesData(row).slice(0, 6)"
                          :key="vehicle.inventory_number" cols="12" sm="6" md="4" class="mb-4">
                          <v-card class="pa-4 vehicle-detail-card" elevation="2"
                            style="border: 2px solid #fb8c00; border-radius: 12px; height: 100%;">
                            <div class="d-flex justify-space-between align-center mb-3">
                              <div class="d-flex align-items-center">
                                <v-icon color="orange" size="24" class="mr-2">mdi-truck</v-icon>
                                <span class="text-h6 font-weight-bold text-orange">
                                  {{ vehicle.inventory_number }}
                                </span>
                              </div>
                              <v-chip v-if="vehicle.status && vehicle.status"
                                :color="getVehicleStatusColor(vehicle.status)" 
                                size="small"
                                class="font-weight-bold">
                                {{ vehicle.status }}
                              </v-chip>
                            </div>
                            
                            <v-divider class="my-2"></v-divider>

                            <div v-if="vehicle.driver_name && vehicle.driver_name !== '-'"
                              class="text-body-2 text-grey-darken-2 mb-2 d-flex align-center">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-account</v-icon>
                              <span class="font-weight-medium">Driver:</span>
                              <span class="ml-1">{{ vehicle.driver_name }}</span>
                            </div>

                            <div class="text-body-2 text-grey-darken-2 mb-2 d-flex align-center">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-truck-cargo-container</v-icon>
                              <span class="font-weight-medium">Type:</span>
                              <span class="ml-1">{{ vehicle.vehicle_type }}</span>
                            </div>

                            <div class="text-body-2 text-grey-darken-2 mb-2 d-flex align-center"
                              v-if="vehicle.next_availability_date">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-calendar</v-icon>
                              <span class="font-weight-medium">Next available:</span>
                              <span class="ml-1">{{ formatDate(vehicle.next_availability_date) }}</span>
                            </div>

                            <div class="text-body-2 text-grey-darken-2 mb-2 d-flex align-center"
                              v-if="vehicle.available_days_count !== '-'">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-clock-outline</v-icon>
                              <span class="font-weight-medium">Available since:</span>
                              <span class="ml-1">{{ vehicle.available_days_count }} days</span>
                            </div>

                            <div class="text-body-2 text-grey-darken-2 mb-2 d-flex align-center" 
                              v-if="vehicle.emp_id !== '-'">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-badge-account</v-icon>
                              <span class="font-weight-medium">Employee ID:</span>
                              <span class="ml-1">{{ vehicle.emp_id }}</span>
                            </div>

                            <div class="text-body-2 text-grey-darken-2 d-flex align-center" 
                              v-if="vehicle.trip_data && vehicle.trip_data.trip_number">
                              <v-icon size="16" class="mr-2" color="grey-darken-1">mdi-map-marker-path</v-icon>
                              <span class="font-weight-medium">Trip:</span>
                              <span class="ml-1">{{ vehicle.trip_data.trip_number }}</span>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      <div class="text-center mt-4" v-if="getRowVehiclesData(row).length > 2">
                        <v-btn color="orange" style="color: white;" large class="px-6 font-weight-bold"
                          @click="openAllDataDialog(getRowVehiclesData(row))">
                          <v-icon class="mr-2">mdi-eye</v-icon>
                          View all {{ getRowVehiclesData(row).length }} vehicles
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expand-transition>

                <v-divider v-if="index < filteredTableData.length - 1" class="my-0"
                  style="border-color: #FFE5B4;" />
              </div>

              <!-- Empty State -->
              <div v-if="filteredTableData.length === 0" class="text-center pa-8">
                <v-icon size="64" color="grey lighten-1">mdi-truck-alert</v-icon>
                <p class="text-h6 text-grey mt-4">No vehicles found for the selected filter</p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <VehicleDataListDialog v-model="showAllVehicleDialog" :vehicleList="vehicleList" />
  </div>
</template>

<script>
import VehicleDataListDialog from "@/components/ModuleBased/dialogForms/VehicleDataListDialog.vue";

export default {
  name: 'VehicleAvailabilityDashboard',

  components: {
    VehicleDataListDialog,
  },

  data() {
    return {
      showAllVehicleDialog: false,
      vehicleList: [],
      expandedSections: {},
      statistics: {
        total_vehicle: 0,
        in_maintenance: 0,
        engaged_vehicle: 0,
        available: 0,
        in_active: 0
      },
      tableHeaders: [],
      tableData: [],
      selectedStatus: 'all',
      isExporting: false,
      statusOptions: [
        { text: 'All Vehicles', value: 'all' },
        { text: 'On Trip', value: 'On Trip' },
        { text: 'Idle', value: 'Idle' },
        { text: 'Inactive', value: 'Deactivated' },
        { text: 'In Maintenance', value: 'In Maintenance'}
      ]
    }
  },

  computed: {
    cards() {
      return [
        {
          label: "In Maintenance",
          value: this.statistics.in_maintenance || 0,
          icon: "mdi-wrench-outline",
          iconColor: "white",
          iconBgColor: "#FBBC04",
          status: "info",
          statusIcon: "mdi-refresh",
          statusColor: "info",
          tooltipMessage: "Vehicle is in maintenance",
          click: () => this.handleCardClick('maintenance')
        },
        {
          label: "On Trip",
          value: this.statistics.engaged_vehicle || 0,
          icon: "mdi-map-marker-path",
          iconColor: "white",
          iconBgColor: "#a855f7",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is on Trip",
          click: () => this.handleCardClick('on_trip')
        },
        {
          label: "Idle",
          value: this.statistics.available || 0,
          icon: "mdi-pause-circle",
          iconColor: "white",
          iconBgColor: "#10b981",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is available",
          click: () => this.handleCardClick('idle')
        },
        {
          label: "Inactive",
          value: this.statistics.in_active || 0,
          icon: "mdi-close-circle",
          iconColor: "white",
          iconBgColor: "#6b7280",
          status: "Info",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is inactive",
          click: () => this.handleCardClick('inactive')
        }
      ]
    },

  filteredTableData() {
  return this.tableData.map(row => {
    const vehiclesData = this.getRowVehiclesData(row);

    return {
      ...row,
      count: {
        value: vehiclesData.length,
        vehicles_data: vehiclesData
      }
    };
  }).filter(row => this.getRowCountValue(row) > 0);
}

  },

  methods: {
    onStatusChange() {
     
      this.getTripWiseAvailabilityChart({ status: this.selectedStatus });
    },
    getRowCountValue(row) {
      if (!row) return 0;
      if (row.count && typeof row.count.value !== 'undefined') {
        return row.count.value;
      }
      if (row.count && Array.isArray(row.count.vehicles_data)) {
        return row.count.vehicles_data.length;
      }
      return 0;
    },

    // Helper method to safely get vehicles data
    getRowVehiclesData(row) {
      if (!row) return [];
      if (row.count && Array.isArray(row.count.vehicles_data)) {
        return row.count.vehicles_data;
      }
      return [];
    },

    handleCardClick(cardType) {
      this.$router.push("/app/admin/asset-management/vehicle/list");
    },

    openAllDataDialog(vehicleData) {
      this.vehicleList = vehicleData;
      this.showAllVehicleDialog = true;
    },

    toggleExpand(depot) {
      this.$set(this.expandedSections, depot, !this.expandedSections[depot]);
    },

    isExpanded(depot) {
      return !!this.expandedSections[depot];
    },

    formatDate(dateString) {
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },

    getChipColor(count) {

      if (count <= 5) return 'info';
      if (count <= 15) return 'info';
      return 'info';
    },

    getVehicleStatusColor(status) {
      const statusColors = {
        'Available': 'success',
        'Assigned': 'warning',
        'On Trip': 'info',
        'Maintenance': 'error',
        'Inactive': 'grey'
      };
      return statusColors[status] || 'primary';
    },

    processPayloadData(payload) {
     
      const data = payload.table_data || payload;
      
      if (!data || !data.headers || !data.row_data) {
        console.error('Invalid payload structure:', payload);
        return;
      }

      this.tableHeaders = data.headers;
      
      // Ensure each row has proper structure
      this.tableData = data.row_data.map(row => {
        if (!row.count) {
          return {
            ...row,
            count: {
              value: 0,
              vehicles_data: []
            }
          };
        }
        
        // Ensure count has both value and vehicles_data
        if (typeof row.count.value === 'undefined') {
          row.count.value = Array.isArray(row.count.vehicles_data) ? row.count.vehicles_data.length : 0;
        }
        
        if (!Array.isArray(row.count.vehicles_data)) {
          row.count.vehicles_data = [];
        }
        
        return row;
      });

      // Calculate total vehicles
      let totalVehicles = 0;
      this.tableData.forEach(row => {
        totalVehicles += this.getRowCountValue(row);
      });
      
      if (totalVehicles > 0) {
        this.statistics.total_vehicle = totalVehicles;
      }
    },

    getStatistics(params) {
      this.$bus.$emit("showLoader", true);
      this.$api.assetsAvailabilityDashboard
        .getAssetsAvailabilityStats(params)
        .then((res) => {
          this.statistics = {
            total_vehicle: res.data.total_vehicle || 0,
             total_vehicles: res.data.total_data || 0,
            in_maintenance: res.data.in_maintenance || 0,
            engaged_vehicle: res.data.engaged_vehicle || 0,
            available: res.data.available || 0,
            in_active: res.data.in_active || 0
          };
        })
        .catch((err) => {
          this.handleApiError(err, "Fetch Statistics Failed");
        })
        .finally(() => {
          this.$bus.$emit("showLoader", false);
        });
    },

  getTripWiseAvailabilityChart(params = {}) {
  this.$bus.$emit("showLoader", true);

  // Always send the status, even if it's 'all'
  const queryParams = { status: params.status || this.selectedStatus };

  this.$api.assetsAvailabilityDashboard
    .getTypeWiseNewVehicleAvailabilityChart(queryParams)
    .then((res) => {
      console.log("API Response:", res.data);
      this.processPayloadData(res.data);
    })
    .catch((err) => {
      console.error("API Error:", err);
      this.handleApiError(err, "Fetch Depot Data Failed");
    })
    .finally(() => {
      this.$bus.$emit("showLoader", false);
    });
},


async exportVehicleData() {
      this.isExporting = true;
      
      try {
  
        const XLSX = await import('xlsx');
        
        const exportData = [];
        
        this.filteredTableData.forEach(depot => {
          const vehiclesData = this.getRowVehiclesData(depot);
          if (vehiclesData.length > 0) {
            vehiclesData.forEach(vehicle => {
              exportData.push({
                'Fleet Number': vehicle.inventory_number,
                "Status Duration":vehicle.status_duration,
                "Current DA Date":vehicle.current_da_date,
                "Last DA Date":vehicle.last_da_date,
                'Vehicle Type': vehicle.vehicle_type,
                'Driver Name': vehicle.driver_name !== '-' ? vehicle.driver_name : '',
                'Employee ID': vehicle.emp_id !== '-' ? vehicle.emp_id : '',
                'Status': vehicle.status,
                'Trip Number': vehicle.trip_data?.trip_number || '',
                'Depot': vehicle.current_depot_name !== '-' ? vehicle.current_depot_name : '',
                'Next Availability': vehicle.next_availability_date || '',
                'Available Days': vehicle.available_days_count !== '-' ? vehicle.available_days_count : '',
                'Trip Start Date': vehicle.trip_data?.est_start_date || '',
                'Trip Start Time': vehicle.trip_data?.est_start_time || '',
                'Trip End Date': vehicle.trip_data?.est_end_date || '',
                'Trip End Time': vehicle.trip_data?.est_end_time || ''
              });
            });
          }
        });

        if (exportData.length === 0) {
          this.$bus.$emit("showToastMessage", {
            message: "No data available to export",
            color: "warning",
            hasActions: true,
          });
          this.isExporting = false;
          return;
        }

     
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        
        const columnWidths = [
          { wch: 20 }, 
          { wch: 15 }, 
          { wch: 20 }, 
          { wch: 15 }, 
          { wch: 12 },
          { wch: 15 },
          { wch: 20 }, 
          { wch: 18 }, 
          { wch: 15 }, 
          { wch: 15 },
          { wch: 15 }, 
          { wch: 15 },
          { wch: 15 },  
          { wch: 15 },
          { wch: 15 },  
          { wch: 15 }    
        ];
        worksheet['!cols'] = columnWidths;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vehicle Availability');

        const filterText = this.statusOptions.find(opt => opt.value === this.selectedStatus)?.text || 'All';
        const timestamp = new Date().toISOString().split('T')[0];
        const filename = `vehicle_availability_${filterText.replace(/\s+/g, '_')}_${timestamp}.xlsx`;
        
        
        XLSX.writeFile(workbook, filename);

        this.$bus.$emit("showToastMessage", {
          message: `Exported ${exportData.length} vehicles successfully`,
          color: "success",
          hasActions: true,
        });
      } catch (error) {
        console.error('Export error:', error);
        this.$bus.$emit("showToastMessage", {
          message: "Failed to export data. ",
          color: "error",
          hasActions: true,
        });
      } finally {
        this.isExporting = false;
      }
    },

    handleApiError(err, defaultMessage) {
      if (err && err.data) {
        const showToast = (message) => {
          this.$bus.$emit("showToastMessage", {
            message,
            color: "error",
            hasActions: true,
          });
        };

        if (err.data.message) {
          showToast(err.data.message);
        } else if (err.data.error?.non_field_errors?.length) {
          showToast(err.data.error.non_field_errors.join(", "));
        } else {
          showToast(defaultMessage);
        }
      }
    },
  },

  beforeMount() {
    this.getStatistics();
    this.getTripWiseAvailabilityChart();
  },
}
</script>

<style scoped>
.hover-effect {
  transition: all 0.3s ease-in-out;
}

.hover-effect:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
}

.vehicle-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.vehicle-card:hover {
  border-color: #dee2e6;
}

.icon-container {
  border-radius: 12px;
}

.text-dark {
  color: #2c3e50 !important;
}

.text-grey {
  color: #6c757d !important;
}

.tiny-btn {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  padding: 0 !important;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.table-header .v-col,
.table-row .v-col {
  display: flex;
  align-items: center;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.table-header .v-col {
  min-height: 45px;
  font-weight: 600 !important;
}

.table-row .v-col {
  min-height: 60px;
}

.text-center {
  justify-content: center !important;
}

.text-left {
  justify-content: flex-start !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.column-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
}

.bg-orange-lighten-5 {
  background-color: #fff3e0 !important;
  border-top: 1px solid rgba(255, 165, 0, 0.1);
}

.border {
  border-width: 1px !important;
  border-style: solid !important;
}

.rounded-b-lg {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.vehicle-detail-card {
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #ffffff 0%, #fffbf5 100%);
}

.vehicle-detail-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(251, 140, 0, 0.2) !important;
}

.expand-btn {
  transition: all 0.2s ease;
}

.expand-btn:hover {
  background-color: #FFD699 !important;
}

.status-filter {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-filter .v-input__control {
  min-height: 40px !important;
}

.export-btn {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.export-btn:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transform: translateY(-1px);
}

@media (max-width: 960px) {
  .status-filter {
    min-width: 180px !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
  
  .vehicle-detail-card .text-body-2 {
    font-size: 0.8rem !important;
  }
}
</style>